import { useState } from "react";

import useButtonStyles from "./styles";
import { Button, LoadingIndicator } from "../VFX-UI";
import { ApiResponse } from "../../../app/model/api/types/apiTypes";
import { FileDto } from "../../../app/model/api/types/dto";
import apiClient from "../../../app/apiClient/apiClient";
import { downloadDocument } from "../../../utility/helpers/fileHelper";
import { ExportButtonProps } from "../../../types";
import { BoxArrowDown } from "react-bootstrap-icons";
import axios, { AxiosRequestConfig } from "axios";

const ExportButton: React.FC<ExportButtonProps> = ({
  style,
  url,
  method = "GET",
  fileName,
  dataDownload = false,
  postData,
  text = "Export",
}) => {
  const buttonsStyles = useButtonStyles();

  const [isLoading, setLoadingState] = useState(false);

  const handleExport = (url: string, dataDownload: boolean) => {
    if (dataDownload === true) {
      downloadFile(url, method, postData);
    } else {
      exportFile(url);
    }
  };

  async function exportFile(urlString: string) {
    await setLoadingState(true);

    const headers = {'Content-Type': 'blob'};
    const config: AxiosRequestConfig = {method: 'GET', responseType: 'arraybuffer', headers};
    try{
      await axios.get(urlString, config).then(
        response => {
          const bloburl = window.URL.createObjectURL(new Blob([response.data],{type:response.headers["content-type"]}));
          const link = document.createElement("a");
          link.href = bloburl;
          link.setAttribute("download",fileName+"");
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      ).finally(()=>setLoadingState(false))
    } catch {
      setLoadingState(false);
    }
    
  }

  async function downloadFile(url: string, method: string, postData: any) {
    setLoadingState(true);

    const response: ApiResponse<FileDto> =
      method.toLowerCase() === "get"
        ? await apiClient.get(url)
        : await apiClient.post(url, postData);

    if (response?.isSuccess && response?.result != null) {
      const byteArray = response.result.content;
      const docType = response.result.mimeType;
      const fileName = response.result.fileName;
      downloadDocument(byteArray, docType, fileName);
      setLoadingState(false);
    }    
  }

  if (isLoading) return <LoadingIndicator notFullPage />;

  return (
    <Button
          style={{ ...buttonsStyles.exportButton, ...style }}
      onClick={() => {
        handleExport(url, dataDownload);
      }}
      >
          <BoxArrowDown /> {text}
      </Button>
  );
};

export default ExportButton;
